import ApiService from "@/core/services/api.service";
import state from "./state";

export default {
  /**
   * Fetch Teacher Leave application list.
   *
   * @param context
   */
  fetchEmployeeAwayApplicationApprovalList(context) {
    ApiService.setHeader();
    return ApiService.query("company/away/application/employee", {
      params: {
        "page[number]": state.pagination.current_page ?? 1,
        "page[size]": state.size,
      },
    }).then((res) => {
      context.commit("setEmployeeAwayApplicationApprovalList", res.data.data);
      context.commit(
        "setEmployeeAwayApplicationApprovalListPagination",
        res.data.meta.pagination
      );
    });
  },
};
